import { store } from '@/store';
import pushNotificationService from '@/services/pushNotifications/pushNotification.service';
import PushNotificationSupportParams from '@/models/entities/push-notifications/push-notification-support-params';
import requireCustomerLogin from '../require-customer-login/require-customer-login';

function pushNotificationsEnabled(pushNotificationSupportParams) {
  try {
    return pushNotificationService.isPushNotificationsSupported(pushNotificationSupportParams);
  } catch (error) {
    console.debug('Push Notifications are not supported:', error);
    return false;
  }
}

/**
 * Reject notification access if it's not enabled
 * @param {*} to destination
 * @param {*} from source
 * @param {*} next next route
 */
export default async function notificationAccess(to, from, next) {
  const isCustomer = store.getters['user/isCustomer'];
  const isEmployee = store.getters['user/isEmployee'];
  const pushNotificationSupportParams = new PushNotificationSupportParams({
    enabledPlatforms: store.getters.getConfiguration.enabledPlatforms,
    webPushConfig: store.getters.getConfiguration.webPushConfig,
    publicVapidKey: store.getters.getConfiguration.publicVapidKey,
    isCustomer,
    isEmployee,
  });

  const isNotificationsEnabled = pushNotificationsEnabled(pushNotificationSupportParams);

  if (!isCustomer && isNotificationsEnabled) {
    requireCustomerLogin(to, from, next);
  } else if (!isNotificationsEnabled) {
    next({ name: 'NotFound' });
  } else {
    next();
  }
}
